/*
 * General custom scripts
 */

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

/*
* StretchedLink
*/
import { StretchedLink } from './front/components/StretchedLink';
new StretchedLink( '.wp-block-button' );

/*
* StretchedLink for Badge
*/
import { StretchedLinkBadge } from './front/components/StretchedLinkBadge';
new StretchedLinkBadge( '.b-badge' );

/*
* StretchedLink for Megamenu
*/
import { StretchedLinkMegamenu } from './front/components/StretchedLinkMegamenu';
new StretchedLinkMegamenu( '.b-megamenu-tab-item' );

/*
* Modal
*/
import { Modal } from './front/components/Modal';
new Modal( '.b-two-columns-image' );
new Modal( '.b-image-component' );

/*
* ImageScreenshot
*/
import { ImageScreenshot } from './front/components/ImageScreenshot';
new ImageScreenshot( '.wp-block-image' );

/*
* TocLink
*/
import { TocLink } from './front/components/TocLink';
new TocLink( '.b-toc' );

/*
* StickySidebar
*/
import { StickySidebar } from './front/components/StickySidebar';
new StickySidebar( '.b-sidebar' );

/*
* ScrollBlob Class
*/
import { ScrollBlob }  from './front/components/ScrollBlob';
new ScrollBlob( '.b-blob.has-blob' );

/*
* ScrollBlob Class
*/
import { OverflowHidden }  from './front/components/TwoColumnsOverflowHidden';
new OverflowHidden( '.b-two-columns' );

/*
* Blog (used by Blog Posts with Load more block)
*/
import { Blog } from './front/Blog';
new Blog( '.js-blog' );

/*
* AltStamp Class
*/
import { AltStamp }  from './front/components/AltStamp';
new AltStamp( '.is-dropzone' );

/*
* BoxImageLink
*/
import { BoxImageLink } from './front/components/BoxImageLink';
new BoxImageLink( '.b-box' );

/*
* MegamenuButtonsMaxWidth
*/
import { MegamenuButtonsMaxWidth } from './front/components/MegamenuButtonsMaxWidth';
new MegamenuButtonsMaxWidth( '.b-megamenu' );
